
import { openCartExpiryModal } from '@/helpers/ModalDialogs'
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class CartExpiryModalStory extends Vue {
  show: boolean = false

  mounted() {
    openCartExpiryModal(this.$t('cartExpire')['title'])
  }
}
